export const removeEmpty = (array) => array.filter(element => {
  if (Object.keys(element).length !== 0) {
    return true;
  }

  return false;
});